var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bookcontent"},_vm._l((_vm.imgs),function(item,index){return _c('read-picture',{key:index,attrs:{"bookid":_vm.bookid,"booktitle":_vm.booktitle,"chapternum":_vm.chapternum,"picparts":item,"picSplitCount":_vm.picSplitCount}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57fa77c2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layer2/book/read-content.vue
// module id = null
// module chunks = 